// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.guest-access-screen {
  min-height: 100%;
  height: 100dvh;
  display: flex;
  flex-direction: column;
  color: #f7f4ec;
  background: #1f2937;
  overflow: hidden;
  box-sizing: border-box;
}

.guest-access-header {
  min-height: 5.25rem;
  padding: 1.2rem 2.75rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid rgba(255, 255, 255, 0.08);
  background: rgba(31, 41, 55, 0.94);
  box-sizing: border-box;
}

.guest-access-brand {
  font-size: 2.7rem;
  line-height: 1;
  font-weight: 800;
  color: #f9fafb;
}

.guest-access-sign-in {
  border: 0;
  padding: 0.45rem 0;
  background: transparent;
  color: #f4f0e9;
  font: inherit;
  font-size: 1.05rem;
  font-weight: 700;
  cursor: pointer;
  transition: opacity 160ms ease;
}

.guest-access-sign-in:hover {
  opacity: 0.72;
}

.guest-access-main {
  flex: 1 1 auto;
  min-height: 0;
  padding: clamp(2rem, 7vh, 5.5rem) 2rem;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow-y: auto;
}

.guest-access-content {
  width: min(67rem, 100%);
  display: grid;
  grid-template-columns: minmax(14rem, 22rem) minmax(0, 1fr);
  align-items: center;
  gap: clamp(2.5rem, 7vw, 7rem);
}

.guest-access-portrait {
  position: relative;
  width: min(100%, 22rem);
  aspect-ratio: 1;
  border-radius: 2rem;
  overflow: hidden;
  background: #2c3f45;
  box-shadow: 0 1.8rem 4.5rem rgba(4, 12, 18, 0.3);
}

.guest-access-portrait::after {
  content: '';
  position: absolute;
  inset: 0;
  border: 1px solid rgba(255, 255, 255, 0.13);
  border-radius: inherit;
  pointer-events: none;
}

.guest-access-portrait img {
  width: 100%;
  height: 100%;
  display: block;
  object-fit: cover;
}

.guest-access-copy {
  max-width: 38rem;
}

.guest-access-eyebrow {
  margin: 0 0 1rem;
  color: #8fc0c5;
  font-size: 0.82rem;
  font-weight: 700;
  letter-spacing: 0.16em;
  text-transform: uppercase;
}

.guest-access-content h1 {
  max-width: 13ch;
  margin: 0;
  color: #f7f4ec;
  font-size: clamp(2.5rem, 5vw, 4.5rem);
  line-height: 0.98;
  font-weight: 800;
  letter-spacing: -0.035em;
}

.guest-access-description {
  max-width: 34rem;
  margin: 1.5rem 0 0;
  color: #cbd5df;
  font-size: clamp(1rem, 1.5vw, 1.22rem);
  line-height: 1.6;
}

.guest-access-progress {
  height: 2.8rem;
  margin-top: 1.6rem;
  display: flex;
  align-items: center;
  gap: 0.48rem;
}

.guest-access-progress span {
  width: 0.62rem;
  height: 0.62rem;
  border-radius: 999px;
  background: #74aeb4;
  animation: guestAccessPulse 900ms ease-in-out infinite;
}

.guest-access-progress span:nth-child(2) {
  animation-delay: 120ms;
}

.guest-access-progress span:nth-child(3) {
  animation-delay: 240ms;
}

.guest-access-actions {
  margin-top: 2rem;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 0.85rem;
}

.guest-access-actions button {
  min-height: 3.2rem;
  padding: 0.78rem 1.4rem;
  border-radius: 999px;
  font: inherit;
  font-weight: 700;
  cursor: pointer;
  transition: filter 160ms ease, border-color 160ms ease, background 160ms ease;
}

.guest-access-secondary {
  border: 1px solid rgba(255, 255, 255, 0.2);
  color: #f4f0e9;
  background: transparent;
}

.guest-access-actions button:hover {
  filter: brightness(1.12);
}

.guest-access-secondary:hover {
  border-color: rgba(255, 255, 255, 0.4);
  background: rgba(255, 255, 255, 0.04);
}

.guest-access-footer {
  min-height: 5.6rem;
  padding: 1rem 2.75rem 1.25rem;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 1.45rem;
  border-top: 1px solid rgba(255, 255, 255, 0.08);
  box-sizing: border-box;
}

.guest-access-footer > span {
  width: 1px;
  height: 2rem;
  background: rgba(255, 255, 255, 0.16);
}

.guest-access-partner {
  display: block;
  width: auto;
  object-fit: contain;
  opacity: 0.78;
}

.guest-access-partner--uoft {
  height: 2.8rem;
  filter: brightness(0) invert(1);
}

.guest-access-partner--camh {
  height: 2.35rem;
}

@keyframes guestAccessPulse {
  0%, 100% {
    transform: translateY(0);
    opacity: 0.42;
  }
  50% {
    transform: translateY(-0.28rem);
    opacity: 1;
  }
}

@media (max-width: 720px) {
  .guest-access-header {
    min-height: 4.25rem;
    padding: 1rem 1.25rem;
  }

  .guest-access-brand {
    font-size: 2rem;
  }

  .guest-access-sign-in {
    font-size: 0.9rem;
  }

  .guest-access-main {
    padding: 1.5rem 1.35rem;
  }

  .guest-access-content {
    grid-template-columns: 1fr;
    justify-items: center;
    gap: 1.6rem;
    text-align: center;
  }

  .guest-access-portrait {
    width: min(48vw, 12rem);
    border-radius: 1.35rem;
  }

  .guest-access-copy {
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .guest-access-content h1 {
    max-width: 14ch;
    font-size: clamp(2.15rem, 10vw, 3.1rem);
  }

  .guest-access-description {
    margin-top: 1rem;
    font-size: 1rem;
  }

  .guest-access-progress {
    margin-top: 1rem;
  }

  .guest-access-actions {
    margin-top: 1.5rem;
    justify-content: center;
  }

  .guest-access-footer {
    min-height: 4.5rem;
    padding: 0.7rem 1rem 0.85rem;
    gap: 1rem;
  }

  .guest-access-partner--uoft {
    height: 2.15rem;
  }

  .guest-access-partner--camh {
    height: 1.8rem;
  }
}

@media (max-width: 420px) {
  .guest-access-actions {
    width: 100%;
    flex-direction: column;
  }

  .guest-access-actions button {
    width: 100%;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/guest/GuestAccessScreen.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb,sBAAsB;EACtB,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kDAAkD;EAClD,kCAAkC;EAClC,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,uBAAuB;EACvB,cAAc;EACd,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,8BAA8B;AAChC;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,cAAc;EACd,aAAa;EACb,sCAAsC;EACtC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;EACvB,aAAa;EACb,0DAA0D;EAC1D,mBAAmB;EACnB,6BAA6B;AAC/B;;AAEA;EACE,kBAAkB;EAClB,uBAAuB;EACvB,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;EACnB,gDAAgD;AAClD;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,2CAA2C;EAC3C,sBAAsB;EACtB,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,SAAS;EACT,cAAc;EACd,qCAAqC;EACrC,iBAAiB;EACjB,gBAAgB;EAChB,wBAAwB;AAC1B;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;EACd,sCAAsC;EACtC,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,cAAc;EACd,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,sDAAsD;AACxD;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,uBAAuB;EACvB,oBAAoB;EACpB,aAAa;EACb,gBAAgB;EAChB,eAAe;EACf,6EAA6E;AAC/E;;AAEA;EACE,0CAA0C;EAC1C,cAAc;EACd,uBAAuB;AACzB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,sCAAsC;EACtC,qCAAqC;AACvC;;AAEA;EACE,kBAAkB;EAClB,6BAA6B;EAC7B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,+CAA+C;EAC/C,sBAAsB;AACxB;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,qCAAqC;AACvC;;AAEA;EACE,cAAc;EACd,WAAW;EACX,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,cAAc;EACd,+BAA+B;AACjC;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE;IACE,wBAAwB;IACxB,aAAa;EACf;EACA;IACE,+BAA+B;IAC/B,UAAU;EACZ;AACF;;AAEA;EACE;IACE,mBAAmB;IACnB,qBAAqB;EACvB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,0BAA0B;IAC1B,qBAAqB;IACrB,WAAW;IACX,kBAAkB;EACpB;;EAEA;IACE,uBAAuB;IACvB,sBAAsB;EACxB;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,uCAAuC;EACzC;;EAEA;IACE,gBAAgB;IAChB,eAAe;EACjB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;IAClB,uBAAuB;EACzB;;EAEA;IACE,kBAAkB;IAClB,4BAA4B;IAC5B,SAAS;EACX;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,cAAc;EAChB;AACF;;AAEA;EACE;IACE,WAAW;IACX,sBAAsB;EACxB;;EAEA;IACE,WAAW;EACb;AACF","sourcesContent":[".guest-access-screen {\n  min-height: 100%;\n  height: 100dvh;\n  display: flex;\n  flex-direction: column;\n  color: #f7f4ec;\n  background: #1f2937;\n  overflow: hidden;\n  box-sizing: border-box;\n}\n\n.guest-access-header {\n  min-height: 5.25rem;\n  padding: 1.2rem 2.75rem;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  border-bottom: 1px solid rgba(255, 255, 255, 0.08);\n  background: rgba(31, 41, 55, 0.94);\n  box-sizing: border-box;\n}\n\n.guest-access-brand {\n  font-size: 2.7rem;\n  line-height: 1;\n  font-weight: 800;\n  color: #f9fafb;\n}\n\n.guest-access-sign-in {\n  border: 0;\n  padding: 0.45rem 0;\n  background: transparent;\n  color: #f4f0e9;\n  font: inherit;\n  font-size: 1.05rem;\n  font-weight: 700;\n  cursor: pointer;\n  transition: opacity 160ms ease;\n}\n\n.guest-access-sign-in:hover {\n  opacity: 0.72;\n}\n\n.guest-access-main {\n  flex: 1 1 auto;\n  min-height: 0;\n  padding: clamp(2rem, 7vh, 5.5rem) 2rem;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  overflow-y: auto;\n}\n\n.guest-access-content {\n  width: min(67rem, 100%);\n  display: grid;\n  grid-template-columns: minmax(14rem, 22rem) minmax(0, 1fr);\n  align-items: center;\n  gap: clamp(2.5rem, 7vw, 7rem);\n}\n\n.guest-access-portrait {\n  position: relative;\n  width: min(100%, 22rem);\n  aspect-ratio: 1;\n  border-radius: 2rem;\n  overflow: hidden;\n  background: #2c3f45;\n  box-shadow: 0 1.8rem 4.5rem rgba(4, 12, 18, 0.3);\n}\n\n.guest-access-portrait::after {\n  content: '';\n  position: absolute;\n  inset: 0;\n  border: 1px solid rgba(255, 255, 255, 0.13);\n  border-radius: inherit;\n  pointer-events: none;\n}\n\n.guest-access-portrait img {\n  width: 100%;\n  height: 100%;\n  display: block;\n  object-fit: cover;\n}\n\n.guest-access-copy {\n  max-width: 38rem;\n}\n\n.guest-access-eyebrow {\n  margin: 0 0 1rem;\n  color: #8fc0c5;\n  font-size: 0.82rem;\n  font-weight: 700;\n  letter-spacing: 0.16em;\n  text-transform: uppercase;\n}\n\n.guest-access-content h1 {\n  max-width: 13ch;\n  margin: 0;\n  color: #f7f4ec;\n  font-size: clamp(2.5rem, 5vw, 4.5rem);\n  line-height: 0.98;\n  font-weight: 800;\n  letter-spacing: -0.035em;\n}\n\n.guest-access-description {\n  max-width: 34rem;\n  margin: 1.5rem 0 0;\n  color: #cbd5df;\n  font-size: clamp(1rem, 1.5vw, 1.22rem);\n  line-height: 1.6;\n}\n\n.guest-access-progress {\n  height: 2.8rem;\n  margin-top: 1.6rem;\n  display: flex;\n  align-items: center;\n  gap: 0.48rem;\n}\n\n.guest-access-progress span {\n  width: 0.62rem;\n  height: 0.62rem;\n  border-radius: 999px;\n  background: #74aeb4;\n  animation: guestAccessPulse 900ms ease-in-out infinite;\n}\n\n.guest-access-progress span:nth-child(2) {\n  animation-delay: 120ms;\n}\n\n.guest-access-progress span:nth-child(3) {\n  animation-delay: 240ms;\n}\n\n.guest-access-actions {\n  margin-top: 2rem;\n  display: flex;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 0.85rem;\n}\n\n.guest-access-actions button {\n  min-height: 3.2rem;\n  padding: 0.78rem 1.4rem;\n  border-radius: 999px;\n  font: inherit;\n  font-weight: 700;\n  cursor: pointer;\n  transition: filter 160ms ease, border-color 160ms ease, background 160ms ease;\n}\n\n.guest-access-secondary {\n  border: 1px solid rgba(255, 255, 255, 0.2);\n  color: #f4f0e9;\n  background: transparent;\n}\n\n.guest-access-actions button:hover {\n  filter: brightness(1.12);\n}\n\n.guest-access-secondary:hover {\n  border-color: rgba(255, 255, 255, 0.4);\n  background: rgba(255, 255, 255, 0.04);\n}\n\n.guest-access-footer {\n  min-height: 5.6rem;\n  padding: 1rem 2.75rem 1.25rem;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 1.45rem;\n  border-top: 1px solid rgba(255, 255, 255, 0.08);\n  box-sizing: border-box;\n}\n\n.guest-access-footer > span {\n  width: 1px;\n  height: 2rem;\n  background: rgba(255, 255, 255, 0.16);\n}\n\n.guest-access-partner {\n  display: block;\n  width: auto;\n  object-fit: contain;\n  opacity: 0.78;\n}\n\n.guest-access-partner--uoft {\n  height: 2.8rem;\n  filter: brightness(0) invert(1);\n}\n\n.guest-access-partner--camh {\n  height: 2.35rem;\n}\n\n@keyframes guestAccessPulse {\n  0%, 100% {\n    transform: translateY(0);\n    opacity: 0.42;\n  }\n  50% {\n    transform: translateY(-0.28rem);\n    opacity: 1;\n  }\n}\n\n@media (max-width: 720px) {\n  .guest-access-header {\n    min-height: 4.25rem;\n    padding: 1rem 1.25rem;\n  }\n\n  .guest-access-brand {\n    font-size: 2rem;\n  }\n\n  .guest-access-sign-in {\n    font-size: 0.9rem;\n  }\n\n  .guest-access-main {\n    padding: 1.5rem 1.35rem;\n  }\n\n  .guest-access-content {\n    grid-template-columns: 1fr;\n    justify-items: center;\n    gap: 1.6rem;\n    text-align: center;\n  }\n\n  .guest-access-portrait {\n    width: min(48vw, 12rem);\n    border-radius: 1.35rem;\n  }\n\n  .guest-access-copy {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n  }\n\n  .guest-access-content h1 {\n    max-width: 14ch;\n    font-size: clamp(2.15rem, 10vw, 3.1rem);\n  }\n\n  .guest-access-description {\n    margin-top: 1rem;\n    font-size: 1rem;\n  }\n\n  .guest-access-progress {\n    margin-top: 1rem;\n  }\n\n  .guest-access-actions {\n    margin-top: 1.5rem;\n    justify-content: center;\n  }\n\n  .guest-access-footer {\n    min-height: 4.5rem;\n    padding: 0.7rem 1rem 0.85rem;\n    gap: 1rem;\n  }\n\n  .guest-access-partner--uoft {\n    height: 2.15rem;\n  }\n\n  .guest-access-partner--camh {\n    height: 1.8rem;\n  }\n}\n\n@media (max-width: 420px) {\n  .guest-access-actions {\n    width: 100%;\n    flex-direction: column;\n  }\n\n  .guest-access-actions button {\n    width: 100%;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
